import type { BodyProfile } from "../../shared/types";

export function bodySourceLabel(profile: BodyProfile): string {
  if (profile.provider === "fityoux-vision-v1") return "FitYouX Vision v1";
  if (profile.provider === "external") return "Professional scan provider";
  return "Legacy demo profile";
}

export function bodyReviewLabel(profile: BodyProfile): string {
  return profile.reviewStatus === "approved" ? "Modelist approved" : "Modelist review required";
}
